import * as yup from 'yup';
import { OfferEligibilityType } from 'legacy/events/types';

export const offerValidationSchema = yup.object({
  name: yup.string().required('Name is required'),
  rewards: yup.object().shape({
    kickbackRewards: yup.object().shape({
      value: yup.number().min(0.01, 'Value must be greater than 0').required()
    })
  }),
  eligibilityCriteria: yup.array().of(
    yup.object().shape({
      selector: yup.string().required(),
      items: yup
        .array()
        .when('selector', {
          is: OfferEligibilityType.USERS,
          then: yup.array().min(1, 'Users are required').required(),
          otherwise: yup.array().notRequired()
        })
        .when('selector', {
          is: OfferEligibilityType.ASSOCIATIONS,
          then: yup.array().min(1, 'Associations are required').required(),
          otherwise: yup.array().notRequired()
        })
        .when('selector', {
          is: OfferEligibilityType.ORGANIZATIONS,
          then: yup.array().min(1, 'Organizations are required').required(),
          otherwise: yup.array().notRequired()
        })
    })
  )
});
